export const getCardProportions = (cardWidth) => {
    const proportions = {};
    switch (cardWidth) {
        default:
            proportions.width = 20;
            proportions.padding = 66.6667;
            break;
    }
    return proportions;
};



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/methods/index.js